import {
    ProposalModel,
    SectionItemModel,
    SortOption,
    SortProperty,
    SortSettings
} from '../interfaces';

export function getSorted(
    collection: SectionItemModel[],
    sortOption: SortOption | null,
    sortSettings: SortSettings
) {
    if (!sortOption) return collection;

    const newCollection: SectionItemModel[] = [];

    for (const item of collection) {
        const newItem = {...item};
        newItem.proposals.sort((a, b) => {
            return compareByPriority(a, b, sortOption);
        });
        newCollection.push(newItem);
    }

    if (sortSettings.sortArticles)
        newCollection.sort((a, b) => compareByPriority(a.proposals[0], b.proposals[0], sortOption));

    return newCollection;
}

function compareByPriority(a: ProposalModel, b: ProposalModel, sortOption: SortOption) {
    // Приоритетность сортировки по умолчанию
    let propertiesBySortPriority = ['firstPrice', 'deliveryDays', 'rating', 'price', 'quantity'];
    // Определяем выбранную сортировку и переставляем её в начало
    const sortProperty = getPropertyNameForSort(sortOption.property);
    propertiesBySortPriority = propertiesBySortPriority.filter((item) => item !== sortProperty);
    propertiesBySortPriority.unshift(sortProperty);

    // Сортировки по умолчанию
    const defaultDirection = new Map<string, number>();
    defaultDirection.set('firstPrice', 1);
    defaultDirection.set('deliveryDays', 1);
    defaultDirection.set('rating', -1);
    defaultDirection.set('price', 1);
    defaultDirection.set('quantity', -1);

    let c = 0;

    for (const property of propertiesBySortPriority) {
        const key = property as keyof ProposalModel;

        if (typeof a[key] === 'string' && typeof b[key] === 'string') {
            if (key === 'webSupplierName') {
                // Объединяем supplierName и webSupplierName в один массив
                const aSuppliers = [a.supplierName, a.webSupplierName]
                    .filter(Boolean)
                    .sort((x, y) => x.localeCompare(y, 'ru', {sensitivity: 'base'}));

                const bSuppliers = [b.supplierName, b.webSupplierName]
                    .filter(Boolean)
                    .sort((x, y) => x.localeCompare(y, 'ru', {sensitivity: 'base'}));

                const aValue = aSuppliers.join(' ');
                const bValue = bSuppliers.join(' ');

                c = aValue.localeCompare(bValue, 'ru', {sensitivity: 'base'});
            }
            // Другие строковые поля
            else if (key === 'source') {
                c = (a.source as string).localeCompare(b.source as string, 'ru', {
                    sensitivity: 'base'
                });
            } else {
                // Обычное строковое сравнение
                c = (a[key] as string).localeCompare(b[key] as string, 'ru', {
                    sensitivity: 'base'
                });
            }
        } else if (isNumber(a[key]) && isNumber(b[key])) {
            c = (a[key] as number) - (b[key] as number);
        }

        // если элементы отличаются
        if (c !== 0) {
            // если сортируем по основному полю, то используем переданный порядок сортировки
            if (sortProperty === property) {
                if (sortOption.direction === 'desc') c *= -1;
            } else {
                // если сортируем по дополнительному полю, то используем порядок сортировки по умолчанию
                c *= defaultDirection.get(property) || 1;
            }
            break;
        }
    }

    return c;
}

function isNumber(value: any) {
    return typeof value === 'number';
}

function getPropertyNameForSort(sortProperty: SortProperty) {
    if (sortProperty === SortProperty.Source) return 'source';
    if (sortProperty === SortProperty.Supplier) return 'webSupplierName';
    if (sortProperty === SortProperty.FirstPrice) return 'firstPrice';
    if (sortProperty === SortProperty.Price) return 'price';
    if (sortProperty === SortProperty.DeliveryDate || sortProperty === SortProperty.DeliveryDays)
        return 'deliveryDays';
    if (sortProperty === SortProperty.Quantity) return 'quantity';
    if (sortProperty === SortProperty.Rating) return 'rating';
    throw `Unknown sort property: ${sortProperty}`;
}
